import React, { Fragment } from 'react'
import Title from '../../../../components/typography/title.component'
import Button from '../../../../components/buttons/buttons.component'
import AntiFraud from '../../../../components/form-components/anti-fraud.component'
import banner_gift from '../../../../../assets/images/compra-de-pontos/banner-presente.png'
import FontAwesome from 'react-fontawesome'
import RadioButton from '../../../../components/form-components/radio-button.component'
import AnchorButton from '../../../../components/buttons/anchor-button.component'
import DiscountCoupon from './components/discount-coupon.component.jsx'
import banner_purchase from '../../../../../assets/images/compra-de-pontos/banner-compra.png'
import RadioButtonGroup from '../../../../components/form-components/radio-button-group.component'
import AccordionSecondary from '../../../../components/accordion/accordion-secondary.component.jsx'
import banner_gift_mobile from '../../../../../assets/images/compra-de-pontos/banner-presente-m.png'
import banner_purchase_mobile from '../../../../../assets/images/compra-de-pontos/banner-compra-m.png'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { isMobile } from '../../../../helpers'
import { history } from '../../../../helpers/history'
import { withRouter } from 'react-router-dom'
import { Formik, Form } from 'formik'
import { CouponService } from './../../../../services/coupon.service'
import { StyledContent } from '../../../../components/form-components/payment-fields/styled-content.style'
import { BillingAddress } from '../../../../components/form-components'
import { validationSchema } from './validation-schema'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { toastActions, clientActions } from '../../../../actions'
import { Creators as Coupon20kCreators } from '../../../../ducks/coupon-20k/coupon-20k'
import { getPointsOptionsLimitedByAvailable } from './points-options'
import { StyledPointsPurchasePage, StyledForm } from './styles.style'
import PaymentFields, {
	paymentFieldsInitialValues,
} from '../../../../components/form-components/payment-fields/payment-fields.component'
import {
	CheckboxToggleInput,
	SelectInput,
} from '../../../../components/form-components/inputs.component'
import {
	updateCoupon,
	onSubmit,
	onChangeSelectPointsQuantity,
	renderWithoutLimit,
	renderGiftCpf,
	renderPurchaseBalanceAfterBuy,
} from './points-purchase.functions'

import { openDebitAuthentication } from '../payment/debit.functions'
import store from '../../../../helpers/store'

const staticValues = {
	anualPointsLimit: 250000,
	giftRoute: `${routes.CLIENTE}/compra-de-pontos-presente`,
}

const numberOfInstallments = 6

class PointsPurchasePage extends React.PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			receiverPerson: null,
			changeAddressModalIsOpen: false,
			newAddressModalIsOpen: false,
			isGift: undefined,
			value: 0,
			points: 0,
			discountPercentage: 0,
			invalidCoupon: true,
			availablePointsToBuy: 0,
			pointsToBuy: [],
			paymentOption: '',
			isGift: this.props.location.pathname == staticValues.giftRoute,
			isOpen: false,
			onClose: false,
			htmlDebitContent: '',
			shouldRenderDebtAuthentication: false,
		}

		this.cpfRef = React.createRef()

		this.renderGiftCpf = (props) => renderGiftCpf.call(this, props)
		this.onChangeSelectPointsQuantity = onChangeSelectPointsQuantity.bind(
			this
		)
		this.renderPurchaseBalanceAfterBuy = () =>
			renderPurchaseBalanceAfterBuy.call(this)
		this.updateCoupon = updateCoupon.bind(this)
		this.selectedPaymentOption = this.selectedPaymentOption.bind(this)
		this.goToPointsPurchase = () =>
			this.props.history.push(`${routes.CLIENTE}/compra-de-pontos`)
		this.goToGiftPointsPurchase = () =>
			this.props.history.push(`${routes.CLIENTE}/compra-de-pontos-presente`)
		this.onSubmit = onSubmit.bind(this)
		this.renderWithoutLimit = () => renderWithoutLimit.call(this)
		this.onClose = this.onClose.bind(this)

		const functions = {
			renderGiftCpf: this.renderGiftCpf,
			onChangeSelectPointsQuantity: this.onChangeSelectPointsQuantity,
			renderPurchaseBalanceAfterBuy: this.renderPurchaseBalanceAfterBuy,
			updateCoupon: this.updateCoupon,
			selectedPaymentOption: this.selectedPaymentOption,
			onClose: this.onClose,
		}

		this.formikRender = (props) => {
			const {
				isGift,
				value,
				pointsToBuy,
				discountPercentage,
				points,
				invalidCoupon,
				paymentOption,
			} = this.state
			const { availablePointsToBuy, id } = this.props
			const valueDiscount = CouponService.applyDiscount(
				value,
				discountPercentage
			)

			return formikRender(
				props,
				{
					id,
					value,
					points,
					isGift,
					pointsToBuy,
					valueDiscount,
					invalidCoupon,
					paymentOption,
					discountPercentage,
					availablePointsToBuy,
				},
				functions
			)
		}
	}

	componentWillMount() {
		this.props.getAvailablePointsToBuy()
		const { isGift } = this.state
		this.initialValues = {
			isGift,
			cpf: '',
			points: 0,
			acceptTerms: false,
			...paymentFieldsInitialValues({ installments: true }),
		}
	}

	componentWillReceiveProps(nextProps) {
		const { availablePointsToBuy } = this.state
		if (nextProps.availablePointsToBuy != availablePointsToBuy) {
			this.setState({
				pointsToBuy: getPointsOptionsLimitedByAvailable(
					nextProps.availablePointsToBuy
				),
			})
		}
	}

	selectedPaymentOption(option) {
		this.setState({ paymentOption: option })
	}

	onClose() {
		this.setState({ isOpen: false })
		// clear form
		this.refs.form.resetForm()
	}

	openDebitAuthentication = () => {
		const { danger, hideLoading } = this.props
		const { htmlDebitContent } = this.state
		let status = openDebitAuthentication(htmlDebitContent)
		if (!status) {
			history.push(`${routes.CLIENTE}/erro-processamento`)
			hideLoading()
			danger({
				message:
					'Não foi possível conectar com o emissor, por favor, utilize outro cartão ou forma de pagamento.',
			})
		}
	}

	render() {
		const { isGift, shouldRenderDebtAuthentication } = this.state
		const { balancePoints, availablePointsToBuy } = this.props
		const noLimit = availablePointsToBuy != null && availablePointsToBuy <= 0

		return availablePointsToBuy == undefined ? null : noLimit ? (
			this.renderWithoutLimit()
		) : (
				<React.Fragment>
					<StyledPointsPurchasePage small>
						<AntiFraud isPoints={true} />
						<Title>Compra de pontos</Title>
						<h3 className="center bold">
							Saldo atual{' '}
							<span className="blue">
								{Number(balancePoints).toLocaleString('pt-BR')}
							</span>{' '}
						pontos Muviflex
					</h3>
					</StyledPointsPurchasePage>
					<StyledPointsPurchasePage>
						<img
							style={{ width: '100%' }}
							src={
								isMobile()
									? isGift
										? banner_gift_mobile
										: banner_purchase_mobile
									: isGift
										? banner_gift
										: banner_purchase
							}
							alt="Banner da compra de pontos"
						/>
					</StyledPointsPurchasePage>
					<StyledPointsPurchasePage small>
						<div className="whose-points">
							<RadioButtonGroup id="isGift" gap="15px" {...this.props}>
								<RadioButton
									isActive={!isGift}
									onClick={this.goToPointsPurchase}>
									<StyledContent>
										<FontAwesome name="user-o" size="2x" /> Minha conta
								</StyledContent>
								</RadioButton>
								<RadioButton
									isActive={isGift}
									onClick={this.goToGiftPointsPurchase}>
									<StyledContent>
										<FontAwesome name="gift" size="2x" />
									Pontos de presente
								</StyledContent>
								</RadioButton>
							</RadioButtonGroup>
						</div>
						<Formik
							ref="form"
							initialValues={this.initialValues}
							validationSchema={validationSchema}
							onSubmit={this.onSubmit}
							render={this.formikRender}
						/>
					</StyledPointsPurchasePage>
					{shouldRenderDebtAuthentication
						? this.openDebitAuthentication()
						: null}
				</React.Fragment>
			)
	}
}

function formikRender(
	props,
	{
		id,
		value,
		points,
		isGift,
		pointsToBuy,
		valueDiscount,
		invalidCoupon,
		paymentOption,
		discountPercentage,
		availablePointsToBuy,
	},
	{
		renderGiftCpf,
		onChangeSelectPointsQuantity,
		renderPurchaseBalanceAfterBuy,
		updateCoupon,
		selectedPaymentOption,
	}
) {
	const paymentMethod = props.values.paymentMethod
	const couponCode = props.values.couponCode
	return (
		<Form noValidate onSubmit={props.handleSubmit}>
			<StyledForm>
				{isGift && renderGiftCpf(props)}
				<div>
					<h3 className="orange semi-bold">
						Selecione a quantidade de pontos que deseja comprar
					</h3>
					<div className="buy-points">
						<div>
							<SelectInput
								id="points"
								label="Quantidade de pontos *"
								options={pointsToBuy}
								onValueChange={onChangeSelectPointsQuantity}
								{...props}
							/>
							<p className="blue bold points-info mTop">
								Nas compras acima de 20 mil pontos ganhe 5% de
								desconto.*
							</p>
							<p className="points-info">
								Limite anual:{' '}
								{Number(staticValues.anualPointsLimit).toLocaleString(
									'pt-BR'
								)}{' '}
								pontos para compra.
							</p>
							<p className="points-info">
								Você ainda pode comprar{' '}
								{Number(availablePointsToBuy).toLocaleString('pt-BR')}{' '}
								pontos
							</p>
						</div>
						<div>
							<div className="label">Valor a pagar</div>
							<div className="value">{Number(value).$toReais()}</div>
						</div>
						{!isGift && renderPurchaseBalanceAfterBuy()}
					</div>
				</div>
				<div>
					<AccordionSecondary
						arrow
						multiple
						noAnimated
						items={[
							{
								title: 'Possui cupom de desconto?',
								initiallyOpened: false,
								content: (
									<DiscountCoupon
										value={value}
										onApply={updateCoupon}
										discountPercentage={discountPercentage}
										{...props}
									/>
								),
							},
						]}
					/>
				</div>
				<div>
					<h3 className="orange semi-bold">Endereço de cobrança</h3>
					<BillingAddress clientId={id} />
				</div>
				<div>
					<h3 className="orange semi-bold">Forma de pagamento</h3>
					<div className="payment-fields">
						<PaymentFields
							{...props}
							noOnlineDebt
							selectedPaymentOption={selectedPaymentOption}
							orderValue={value}
							noInstallmentsMessage={
								'Escolha a quantidade de pontos primeiro'
							}
						/>
					</div>
					{points > 0 ? (
						<div className="payment-resume-container">
							<h3 className="orange semi-bold">Resumo da compra</h3>
							<div className="payment-resume">
								<p className="description-discounts">
									<span className="descrip">Quantidade:</span>
									<span className="descrip-value">
										{Number(points).toLocaleString('pt-BR')} pontos
									</span>
								</p>
								<p className="description-discounts">
									<span className="descrip">Valor:</span>
									<span className="descrip-value">
										{Number(value).$toReais()}
									</span>
								</p>
								{couponCode === 'DESCONTO20MIL' ||
									(couponCode === '' && points >= 20000) ? (
										<p className="description-discounts">
											<span className="descrip">
												Desconto Promoção 20 mil pontos:
										</span>
											<span className="descrip-value">
												{Number(
													value -
													CouponService.applyDiscount(
														value,
														5
													).toFixed(2)
												).$toReais()}
											</span>
										</p>
									) : (
										''
									)}
								{!invalidCoupon && couponCode !== 'DESCONTO20MIL' ? (
									<p className="description-discounts">
										<span className="descrip">Desconto Cupom:</span>
										<span className="descrip-value">
											{Number(
												(value - valueDiscount).toFixed(2)
											).$toReais()}
										</span>
									</p>
								) : (
										''
									)}
								{paymentMethod === 'bankSlip' &&
									couponCode === 'DESCONTO20MIL' ? (
										<Fragment>
											<p className="description-discounts">
												<span className="descrip">
													Desconto pagamento via boleto:
											</span>
												<span className="descrip-value">5%</span>
											</p>
											<p className="label-boleto">
												<span>Valor total:&nbsp;</span>
												<div className="value">
													{Number(
														CouponService.applyDiscount(
															valueDiscount,
															5
														).toFixed(2)
													).$toReais()}
												</div>
											</p>
										</Fragment>
									) : paymentMethod === 'bankSlip' &&
										couponCode === '' &&
										points >= 20000 ? (
											<Fragment>
												<p className="description-discounts">
													<span className="descrip">
														Desconto pagamento via boleto:
											</span>{' '}
													<span className="descrip-value">5%</span>
												</p>
												<p className="label-boleto">
													<span>Valor total:&nbsp;</span>
													<div className="value">
														{Number(
															CouponService.applyDiscount(
																value,
																10
															).toFixed(2)
														).$toReais()}
													</div>
												</p>
											</Fragment>
										) : paymentMethod === 'bankSlip' &&
											couponCode === '' ? (
												<Fragment>
													<p className="description-discounts">
														<span className="descrip">
															Desconto pagamento via boleto:
											</span>
														<span className="descrip-value">5%</span>
													</p>
													<p className="label-boleto">
														<span>Valor total:&nbsp;</span>
														<div className="value">
															{Number(
																CouponService.applyDiscount(
																	valueDiscount,
																	5
																).toFixed(2)
															).$toReais()}
														</div>
													</p>
												</Fragment>
											) : couponCode === '' && points >= 20000 ? (
												<p className="label-boleto">
													<span>Valor total:&nbsp;</span>
													<div className="value">
														{Number(
															CouponService.applyDiscount(
																value,
																5
															).toFixed(2)
														).$toReais()}
													</div>
												</p>
											) : (
													<p className="label-boleto">
														<span>Valor total:&nbsp;</span>
														<div className="value">
															{Number(valueDiscount.toFixed(2)).$toReais()}
														</div>
													</p>
												)}
							</div>
						</div>
					) : (
							''
						)}

					<div>
						<p>
							Declaro que li e concordo com os{' '}
							<AnchorButton href="/regulamento" noStyle targetBlank>
								termos e condições de uso
							</AnchorButton>{' '}
							e com o{' '}
							<AnchorButton href="/politica-de-privacidade" noStyle targetBlank>
								termo de privacidade
							</AnchorButton>{' '}
							para compra de pontos do programa Muviflex *
						</p>
						<CheckboxToggleInput id="acceptTerms" {...props} />
						{paymentMethod === 'debitCard' ? (
							<p style={{ marginTop: '25px' }}>
								<b>Atenção:</b> caso você possua um programa anti
								pop-up, será necessário desativá-lo.
							</p>
						) : null}
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
					}}>
					<Button primary type="submit">
						Finalizar compra
					</Button>
				</div>
			</StyledForm>
		</Form>
	)
}

const mapStateToProps = ({ client, user, antiFraud, site, addresses }) => ({
	...client,
	...user,
	...addresses,
	privateMenuState: site.privateMenuState,
	deviceId: antiFraud.sessionID,
})

const mapDispatchToProps = {
	...SiteCreators,
	...toastActions,
	...clientActions,
	setActualCoupon: Coupon20kCreators.setActualCoupon,
}

const connectedPointsPurchasePage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PointsPurchasePage)
)

export { connectedPointsPurchasePage as ModuleRootComponent }
